// Wholesale configuration — single source of truth for the 30-Pack Wholesale Kit

export const WHOLESALE = {
  // Single product offering
  kit: {
    size: 30,
    price: 375.00,
    label: '30 Tails',
    pricePerTail: 12.50,
    suggestedRetailLow: 25,
    suggestedRetailHigh: 45,
    sku: 'WHOLESALE-30PACK',
  },

  // Shipping zones — pre-negotiated UPS 2-Day Air rates for the wholesale kit
  shippingZones: [
    { label: 'Zone 2 (CA / NV / AZ)', range: '$20–25', costPerTail: '$0.67–0.83' },
    { label: 'Zone 4–5 (TX / CO / Midwest)', range: '$29–36', costPerTail: '$0.97–1.20' },
    { label: 'Zone 6–7 (Southeast / NE)', range: '$38–45', costPerTail: '$1.27–1.50' },
    { label: 'Zone 8 (NY / MA / ME)', range: '$45–52', costPerTail: '$1.50–1.73' },
    { label: 'Alaska / Hawaii', range: '$58–67', costPerTail: '$1.93–2.23' },
  ],

  // Shipping disclaimer
  shippingDisclaimer:
    'Rates pre-negotiated UPS 2-Day Air. Subject to change. Shipped in insulated Uline shipper box with dry ice.',

  // Product specifications
  specs: [
    { label: 'Tail Size', detail: '4 oz Cold Water Tail (North Atlantic)' },
    { label: 'Pack Count', detail: '30 tails per wholesale kit' },
    { label: 'Pack Format', detail: 'Gusseted Poly Bags, Loose' },
    { label: 'Prep', detail: 'Wet & dry batter · Deep-fried' },
    { label: 'Preservation', detail: 'Blast-chilled -68°F · Flash-frozen' },
    { label: 'Storage', detail: 'Frozen 0°F / -18°C or below' },
    { label: 'Shelf Life', detail: '8 months from ship date' },
    { label: 'Reheat', detail: 'Deep Fryer 325°F · 5 min' },
    { label: 'Allergens', detail: 'Shellfish, Gluten, Paprika, Garlic' },
  ],
  // Order limits
  minKitsPerOrder: 1,
  maxKitsPerOrder: 50,
} as const
